/**
*
* 作成者：BrangsitaSolution By Ham
* 作成日：2022-06-22
* 
* 内容
* 並び替えをベストセラーに更新した場合に各商品ごとにランキングを表示する。
* loading-barをトリガーとして設定してランキングタグを追加。
**/


// observer target
var target = document.getElementsByClassName('loading-bar')[0];
var rankDisplay = false;

// observer function
var observer = new MutationObserver(mutations => {
  mutations.forEach(mutation => {
   setRank();
  });
});

// observer config
var config = {
  childList: true,	// ターゲットの下位要素の追加及び除去感知
  attributes: true,	// ターゲットの属性変更を感知
  characterData: true,	// ターゲットのデータ変更感知
  subtree: true,	// ターゲットの子ノードの下でも検知
  attributeOldValue: false,	// ターゲットのプロパティ変更前のプロパティ記録
  characterDataOldValue: false	// ターゲットデータ変更前のデータ記録
};

// observe start
observer.observe(target, config);

// observe stop
// observerはトリガーをずっとチェックしないといけないので終了しない。
//observer.disconnect();

window.onload = function () {
  setRank();
}

function setRank(){
  // 表示条件設定
  var displayEl = document.getElementsByClassName('hidden-phone');
  var rank = false;
  var rankNum = 1;
  var pagination = document.getElementsByClassName('pagination__nav-item');
  var page = 1;
  

  for(var c=0;c<pagination.length;c++){
    var clList = pagination[c].classList;
    for(var l=0;l<clList.length;l++){
      if(clList[l] == 'is-active'){
          page = pagination[c].innerText;
      }
    }
  }
  
  for(var i=0;i<displayEl.length;i++){
    if(displayEl[i].classList.length < 2){
      var text = displayEl[i].innerText;
      var display = displayEl[i].innerText.indexOf('件表示');
      if(display > -1){
        var rankNum = text.substr(display-3, 2);
      }
      if(displayEl[i].innerText.indexOf('ベストセラー') > -1){
        rank = true;
      }
    }
  }

  if(rank && !rankDisplay && document.getElementsByClassName('custom-rank-byHam')[0] === undefined){
    // タグ追加
    var tagArea = document.getElementById('shopify-section-template--16096746963180__main').getElementsByClassName('product-item');
    var tagAreaTest = document.getElementsByClassName('product-item');
    var ranking = 1;

    if(page > 1){
      var pageprev = page - 1;
      var prevprod = pageprev * 24;
      ranking = prevprod + 1;
    }
    
    for(var r=0;r<tagArea.length;r++){
      var rankTag = document.createElement('div');
      if(ranking == 1){
      rankTag.innerHTML = "<span class='product-label product-label--on-sale' style='background: linear-gradient(45deg, #B67B03 0%, #DAAF08 45%, #FEE9A0 70%, #DAAF08 85%, #B67B03 90% 100%);'><span>"+(ranking++)+"位</span></span>";
      }
      else if(ranking == 2){
      rankTag.innerHTML = "<span class='product-label product-label--on-sale' style='background:linear-gradient(45deg, #757575 0%, #9E9E9E 45%, #E8E8E8 70%, #9E9E9E 85%, #757575 90% 100%);'><span>"+(ranking++)+"位</span></span>";
      }
      else if(ranking == 3){
      rankTag.innerHTML = "<span class='product-label product-label--on-sale' style='background:linear-gradient(45deg, #a34e03 0%, #bf5b02 45%, #ffbe85 70%, #bf5b02 85%, #a34e03 90% 100%);'><span>"+(ranking++)+"位</span></span>";
      }
      else{
      rankTag.innerHTML = "<span class='product-label product-label--on-sale' style='background-color:#00BADB;'><span>"+(ranking++)+"位</span></span>";
      }
      rankTag.className += "custom-rank-byHam";
      rankTag.style.cssText += "display: flex;justify-content: flex-end;z-index: 2;";
      tagArea[r].prepend(rankTag);
    }
  }
}

